/* eslint-disable class-methods-use-this */
/**
 * V2 text cell template — adds skeleton state while block outputs load.
 * Extends TextCellTemplateOpz so legacy tables stay unchanged.
 */
import React from 'react';
import { Compatible } from '@silevis/reactgrid';
import { Flex, Skeleton } from '@chakra-ui/react';

import {
  TextCell,
  TextCellTemplateOpz,
} from 'pages/PlanPageDetailsOPZ/Inputs/IndicatorPageMultiDim/TextCellTemplateOpz';

export interface TextCellV2 extends TextCell {
  isLoading?: boolean;
}

export class TextCellTemplateOpzV2 extends TextCellTemplateOpz {
  render(
    cell: Compatible<TextCellV2>,
    isInEditMode: boolean,
    onCellChanged: (cell: Compatible<TextCellV2>, commit: boolean) => void,
  ): React.ReactNode {
    if (!isInEditMode && cell?.isLoading) {
      return (
        <Flex width='100%' height='100%' alignItems='center' justifyContent='flex-end' px={2}>
          <Skeleton
            startColor='rgba(255, 255, 255, 0.12)'
            endColor='rgba(255, 255, 255, 0.35)'
            height='14px'
            width='72%'
            borderRadius='4px'
          />
        </Flex>
      );
    }

    return super.render(cell, isInEditMode, onCellChanged);
  }
}
